import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'jquery';
import 'bootstrap';
import './style.scss';
import { App } from './App';
window.initializeApp = function () {
    var element = document.createElement('div');
    document.body.appendChild(element);
    ReactDOM.render(React.createElement(App, {}), element);
};
